import { World } from "./testCase";
import MoveTestCase from "./moveTestCase";
class MoveNoArgumentRoot extends World {
    constructor(testCase) {
        super(testCase);
        this._moveTestCase = testCase;
    }
    moveRight() {
        this.log("Move Right");
        this._moveTestCase.move(1, 0);
    }
    moveLeft() {
        this.log("Move Left");
        this._moveTestCase.move(-1, 0);
    }
    moveUp() {
        this.log("Move Up");
        this._moveTestCase.move(0, -1);
    }
    moveDown() {
        this.log("Move Down");
        this._moveTestCase.move(0, 1);
    }
}
export class MoveNoArgumentTestCase extends MoveTestCase {
    //sceneNode is shared.
    createRoot() {
        return new MoveNoArgumentRoot(this);
    }
    //styleSheet is shared
    createElement(document) {
        let template = document.createElement("template");
        let html = `<div class="move-container">
      <div class="move-grid">
        <div></div>
        <div class="move-item"><button class="move_up w-full btn-darkBackHigh">Up</button></div>
        <div></div>
        <div class="move-item"><button class="move_left w-full btn-darkBackHigh">Left</button></div>
        <div></div>
        <div class="move-item"><button class="move_right w-full btn-darkBackHigh">Right</button></div>
        <div></div>
        <div class="move-item"><button class="move_down w-full btn-darkBackHigh">Down</button></div>
        <div></div>
      </div>
    </div>`;
        html = html.trim(); // Never return a text node of whitespace as the result
        template.innerHTML = html;
        template.content.firstElementChild.getElementsByClassName("move_right")[0]
            .addEventListener("click", () => {
            this.log("Move right");
            this.move(1, 0);
            this.queueEvaluate();
        });
        template.content.firstElementChild.getElementsByClassName("move_left")[0]
            .addEventListener("click", () => {
            this.log("Move left");
            this.move(-1, 0);
            this.queueEvaluate();
        });
        template.content.firstElementChild.getElementsByClassName("move_down")[0]
            .addEventListener("click", () => {
            this.log("Move down");
            this.move(0, 1);
            this.queueEvaluate();
        });
        template.content.firstElementChild.getElementsByClassName("move_up")[0]
            .addEventListener("click", () => {
            this.log("Move up");
            this.move(0, -1);
            this.queueEvaluate();
        });
        return template.content.firstElementChild;
    }
}
